import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import Modal from '../Modal/Modal';
import './ChangePassword.css';
import message from "../../constants/message";

const ChangePassword = ({ loading, error, updatePassword}) => {
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const navigate = useNavigate();
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [errorMessages, setErrorMessages] = useState({});
    // const { state } = location || {}; 
    const userType = queryParams.get('userType') || 'admin'; 
    const loginId = queryParams.get('loginId') || '';

    useEffect(() => {
        console.log("UserType:", userType); 
    }, [userType]);
    
    const validateInput = () => {

        const errors = {};
        const minLength = 8;
        const maxLength = 32;
        if (!currentPassword.trim()) {
            errors.currentPassword = message.REQUIRED_MSG_ONLY;
        } else if (!/^[\x21-\x7E]+$/.test(currentPassword)) {
            errors.currentPassword = message.ALPHA_NUMBERIC_SYMBOL_MSG_ONLY;
        } else if (currentPassword.length < minLength || currentPassword.length > maxLength) {
            errors.currentPassword = message.ALPHA_NUMBERIC_SYMBOL_MSG_ONLY_LENGTH;
        }

        if (!newPassword.trim()) {
            errors.newPassword = message.REQUIRED_MSG_ONLY;
        } else if (!/^[\x21-\x7E]+$/.test(newPassword)) {
            errors.newPassword = message.ALPHA_NUMBERIC_SYMBOL_MSG_ONLY_LENGTH;
        } else if (newPassword.length < minLength || newPassword.length > maxLength) {
            errors.newPassword = message.ALPHA_NUMBERIC_SYMBOL_MSG_ONLY_LENGTH;
        } else if (currentPassword === newPassword) {
            errors.newPassword = message.DIFFERS_MSG;
        }

        if (newPassword !== confirmPassword) {
            errors.confirmPassword = message.MATCHING_MSG;
        }

        setErrorMessages(errors);
        return Object.keys(errors).length === 0;
    };

    const handleBackClick = () => {
        navigate(-1);
    };

    const handleUpdatePassword = async () => {
        if (!validateInput()) {
            return;
        }
    
        try {
            const response = await updatePassword(currentPassword, newPassword, loginId, userType);
            setModalMessage(response?.message || "変更しました。");
            setIsModalOpen(true);

            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');
        } catch (error) {
            const errorMessage = error.response?.data || error.message || "Failed to update ID/PW.";
    
            if (errorMessage.includes("パスワードが正しくありません")) {
                setErrorMessages((prevErrors) => ({
                    ...prevErrors,
                    currentPassword: "パスワードが正しくありません", 
                }));
            } else {
                setModalMessage(errorMessage);
                setIsModalOpen(true);
            }
        }
    };
    

    return (
        <div id='Main' className='MainEdit' >
            <div id='Contents' className='ContentEdit'>
                {isModalOpen && (
                    <Modal
                        isOpen={isModalOpen}
                        onClose={() => {
                            setIsModalOpen(false);
                            // navigate(-1); 
                        }}                        
                        message={modalMessage}
                        
                    />
                )}
                <div id="ajax-view-disp">
                    <div className="display-main">
                        <div className="lay-master-set">
                            <div className="lay-master-set-wrap">
                                <div className="lay-master-set__title" style={{ marginRight: '80px' }}>
                                    <span>パスワードの変更</span>
                                </div>
                                {/* ボタン */}
                                <div className="lay-master-set__form">
                                    <form id="userData">
                                        <div className="wrapper" style={{ textAlign: 'left' }}>
                                            <div className="mail-send__set">
                                                <div className="mail-input">
                                                    {/* ボタン */}
                                                    <div style={{ width: '90%', marginTop: '10px' }}>
                                                        <div style={{ display: 'flex' }}>
                                                            <div style={{ visibility: 'hidden' }}>
                                                                <button
                                                                    type="button"
                                                                    className="mod-btn__adminedit morelong"
                                                                    
                                                                >
                                                                    none
                                                                </button>
                                                            </div>
                                                            
                                                            <div className='add-btn'>
                                                                <button
                                                                    type="button"
                                                                    className="mod-btn__roundborder add"
                                                                    onClick={handleUpdatePassword}
                                                                >
                                                                    変更
                                                                </button>
                                                            </div>
                                                        
                                                            <div className='back-btn'>
                                                                <button
                                                                    type="button"
                                                                    className="mod-btn__adminback back"
                                                                    onClick={handleBackClick}
                                                                >
                                                                    戻る
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* 設定項目 */}
                                                    <div className="mod-form__set">
                                                        <dl style={{ marginTop: '40px' }}>
                                                            <dt>元のパスワード</dt>
                                                            <dd style={{ width: '60%' }}>
                                                                <div className="mod-form__text">
                                                                    <input
                                                                        type="text"
                                                                        className="password-mask" 
                                                                        id="current_password"
                                                                        name="current_password"
                                                                        value={currentPassword}
                                                                        onChange={(e) => setCurrentPassword(e.target.value)}
                                                                        maxLength="32"
                                                                        autoComplete='off'
                                                                    />
                                                                    <div className="error_msg">
                                                                        {errorMessages.currentPassword && <span style={{ color: 'red' }}>{errorMessages.currentPassword}</span>}
                                                                    </div>
                                                                </div>
                                                            </dd>
                                                        </dl>

                                                        <dl style={{ marginTop: '10px' }}>
                                                            <dt>新しいパスワード</dt>
                                                            <dd style={{ width: '60%' }}>
                                                                <div className="mod-form__text">
                                                                    <input
                                                                        type="text"
                                                                        className="password-mask"
                                                                        id="new_password"
                                                                        name="new_password"
                                                                        value={newPassword}
                                                                        onChange={(e) => setNewPassword(e.target.value)}
                                                                        maxLength="32"
                                                                        autoComplete='off'
                                                                    />
                                                                    <div className="error_msg">
                                                                        {errorMessages.newPassword && <span style={{ color: 'red' }}>{errorMessages.newPassword}</span>}
                                                                    </div>
                                                                </div>
                                                            </dd>
                                                        </dl>
                                                        <dl style={{ marginTop: '10px' }}>
                                                            <dt>新しいパスワード(確認用)</dt>
                                                            <dd style={{ width: '60%' }}>
                                                                <div className="mod-form__text">
                                                                    <input
                                                                        type="text"
                                                                        className="password-mask"
                                                                        id="confirm_password"
                                                                        name="confirm_password"
                                                                        value={confirmPassword}
                                                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                                                        maxLength="32"
                                                                        autoComplete='off'
                                                                    />
                                                                </div>
                                                                <div className="error_msg">
                                                                    {errorMessages.confirmPassword && <span style={{ color: 'red' }}>{errorMessages.confirmPassword}</span>}
                                                                </div>
                                                            </dd>
                                                        </dl>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

ChangePassword.propTypes = {
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string,
    updatePassword: PropTypes.func.isRequired,
    loginId: PropTypes.string,
    userType: PropTypes.string
};

export default React.memo(ChangePassword);
